import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import * as moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import '../../i18n';
import { CalendarLight } from '../Icons'

const EndDateInput = (props) => {
    const { t } = useTranslation();
    const { handleFilters, locale, endDate, setEndDate, isDesktop } = props

    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <React.Fragment>
            <div class="mt-1 flex rounded-md shadow-sm">
                <span
                    class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-white"
                    onClick={onClick}
                    ref={ref}
                >
                    <CalendarLight
                        width="15px"
                        height="15px"
                        color="#868D96"
                    />
                </span>
                <input
                    type="text"
                    name="event-date"
                    class="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:focus:ring-transparent focus:border-gray-300 sm:text-sm border-gray-300"
                    style={{ height: '38px' }}
                    onClick={onClick}
                    ref={ref}
                    value={value}
                />
            </div>
        </React.Fragment>
    ));

    return (
        <div className={`w-full ${isDesktop ? 'w-49 pl-3 mb-6 md:mb-0' : 'md:w-1/3 mb-6 md:mb-0 self-end px-3'}`}>
            <label className={`block text-sm ${isDesktop ? 'mb-1' : 'mb-0.5'}`}>{t('end_date')}</label>
            <DatePicker
                name={endDate}
                wrapperClassName="w-full"
                selected={endDate}
                onChange={(endDate) => { handleFilters('endDate', moment(endDate).format('YYYY-MM-DD')); setEndDate(endDate) }}
                dateFormat={locale === 'en' ? 'MM/dd/yy' : 'dd/MM/yy'}
                customInput={<CustomInput />}
            />
        </div>
    )
}

export default EndDateInput;